<template>
  <div class="flex flex-col sm:flex-row sm:justify-between sm:items-center gap-3 mb-4 bg-white px-4 py-3">
    <AnalyticsDateRangePicker v-model="dateRange" :placeholder="t('select_period')" />
    <slot />
  </div>
</template>

<script>
import { useI18n } from "vue-i18n";
import { AnalyticsDateRangePicker, currentMonthRange, inputDateFormat } from "@estaly/ui";
import { format } from "date-fns";
import { fr } from "date-fns/locale";

export default {
  components: { AnalyticsDateRangePicker },

  emits: ["date-change"],

  setup() {
    const { t } = useI18n();
    return { t };
  },

  data() {
    return {
      dateRange: currentMonthRange().map((date) => inputDateFormat(date)),
    };
  },

  watch: {
    dateRange: {
      immediate: true,
      handler(newDate) {
        if (!Array.isArray(newDate) || !newDate[0] || !newDate[1]) return;
        const formattedMonth = format(new Date(newDate[1]), "MMMM yyyy", { locale: fr });
        const currentMonthLabel = formattedMonth.charAt(0).toUpperCase() + formattedMonth.slice(1);
        this.$emit("date-change", { start: newDate[0], end: newDate[1], currentMonth: currentMonthLabel });
      },
    },
  },
};
</script>

<i18n src="./RetailAnalyticsHeader.i18n.json"></i18n>
